var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.draw_fields.length > 0
        ? _c(
            "b-container",
            {
              staticClass: "border insd border-top-0 p-3",
              attrs: { fluid: "" },
            },
            [
              _c(
                "b-row",
                { attrs: { cla: "", ss: "doc_title" } },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    _vm._l(_vm.draw_fields, function (field) {
                      return _c(
                        "b-row",
                        { key: field.id, staticClass: "doc_title mt-2" },
                        [
                          _c("b-col", { attrs: { sm: "3" } }, [
                            _c(
                              "label",
                              { attrs: { for: field.field_type + field.id } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(field.field_name) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "9" } },
                            [
                              _c("b-form-input", {
                                staticClass: "fs-xl",
                                attrs: {
                                  type: "text",
                                  disabled: true,
                                  size: "sm",
                                },
                                model: {
                                  value: field.field_val_to_show,
                                  callback: function ($$v) {
                                    _vm.$set(field, "field_val_to_show", $$v)
                                  },
                                  expression: "field.field_val_to_show",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel mt-5", attrs: { id: "panel-12" } },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: !_vm.finish_load, rounded: "xl" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
                        },
                        [
                          _c("h2", [
                            _vm._v("\n\t\t\t\t\t\tДодаткова  "),
                            _c("span", { staticClass: "fw-300" }, [
                              _vm._v("Інформація"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-toolbar pr-3 align-self-end",
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass: "nav nav-tabs border-bottom-0",
                                  attrs: {
                                    id: "demo_panel-tabs",
                                    role: "tablist",
                                  },
                                },
                                _vm._l(this.active_tabs, function (tab) {
                                  return _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link cursor-pointer",
                                        class: { active: tab.is_active },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setActiveTab(tab.type)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(tab.name) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "panel-container show" }, [
                        _c(
                          "div",
                          { staticClass: "panel-content" },
                          [
                            _vm.current_tab.type === "1c"
                              ? _c("data_1c", {
                                  attrs: {
                                    owner: _vm.owner,
                                    addon_fields: this.draw_fields,
                                    data: _vm.pai_info.data_1c,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.current_tab.type === "map"
                              ? _c("pai_map", {
                                  attrs: {
                                    map_id: this.kadastr_v,
                                    owner: _vm.owner,
                                    addon_fields: this.draw_fields,
                                    data_1c: _vm.pai_info.data_1c,
                                    data_panorama: _vm.pai_info.data_panorama,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }